import { api } from "./configs/axiosConfigs"

export const RenditionBuildingSpentAPI = {
    getRenditionBuildingSpents: async (idcompany: number, data?: any) => {
        const response = await api.get(
        '/reportSpentBuilding',
        {
            params: {
                ...data,
                idcompany
            }
        }
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    create: async (data: any) => {
        const response = await api.post(
            '/reportSpentBuilding/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    insertBeforeSpent: async (id:number, data: any) => {
        const response = await api.post(
            `/reportSpentBuilding/insertBeforeSpent/${id}`, data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    edit: async (id: number, data: any) => {
        const response = await api.post(
        `/reportSpentBuilding/update/${id}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    delete: async (id: number, idcompany: number) => {
        const response = await api.delete(
        `/reportSpentBuilding/${id}`,
        {
            params: {
                idcompany
            }
        }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    }
}